import React, { useEffect } from "react";
import { LabelDollarFormatted, ButtonText } from "@loanbossinc/component-library";

import { PaddedWrapper, Row } from "../styles";

import { ResultTextWrapper, CalcResultWrapper } from "./calculatedFieldStyles";

import { calculateResult } from "./index";

const PreviewBar = props => {
  const { calculations, initialValue, areCalculationsValid, setCalculatedFieldSelections, previewValue } = props;

  useEffect(() => {
    if (initialValue && !previewValue && previewValue !== 0) {
      setCalculatedFieldSelections({ previewValue: initialValue });
    }
  }, [initialValue, previewValue]);

  const onCalculate = () => {
    const result = calculateResult(calculations);
    setCalculatedFieldSelections({ previewValue: result });
  };

  let buttonText = "Preview";
  if (previewValue || previewValue === 0) {
    buttonText = "Recalculate";
  }

  return (
    <Row>
      <PaddedWrapper>
        <ResultTextWrapper>Calculation Result</ResultTextWrapper>
      </PaddedWrapper>
      <div style={{ display: "flex" }}>
        {calculations && calculations.length > 1 && (
          <ButtonText
            label={
              <div style={{ marginRight: "0.3em" }}>{buttonText}</div>
            }
            onClick={onCalculate}
            disabled={!areCalculationsValid}
          />
        )}
        <PaddedWrapper>
          <CalcResultWrapper>
            <LabelDollarFormatted value={previewValue} decimals={2} />
          </CalcResultWrapper>
        </PaddedWrapper>
      </div>
    </Row>
  );
};

export default PreviewBar;
